export const normalizeId = (value) => {
  if (!value) return '';

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    if (value._id) return normalizeId(value._id) || String(value._id);
    if (value.id) return normalizeId(value.id) || String(value.id);
    if (value.$oid) return String(value.$oid);
    const stringValue = value.toString?.();
    if (stringValue && stringValue !== '[object Object]') return stringValue;
    return '';
  }

  return String(value);
};

export const resolveMatchManagerId = ({ match, tournament, currentUser, user } = {}) =>
  normalizeId(match?.matchManager) ||
  normalizeId(match?.matchManagerId) ||
  normalizeId(match?.assignedMatchManager) ||
  normalizeId(tournament?.matchManager) ||
  normalizeId(tournament?.matchManagerId) ||
  normalizeId(tournament?.assignedMatchManager) ||
  normalizeId(currentUser) ||
  normalizeId(user);
